module.exports = __webpack_public_path__ + "static/img/general01.3778836d.png";